import { TypeKeys, ActionTypes } from '../actions/index';

const getInitialState = (): WorkoutsState => {
  return {
    filterCount: 0,
    filters: noWorkoutFilters(),
    searchTerm: null,
  };
};

const workouts = (
  state = getInitialState(),
  action: ActionTypes
): WorkoutsState => {
  switch (action.type) {
    case TypeKeys.SET_WORKOUT_FILTERS: {
      const filterCount = countFilters(action.filters);
      return {
        ...state,
        filters: { ...state.filters, ...action.filters },
        filterCount,
      };
    }
    case TypeKeys.SEARCH_WORKOUTS: {
      return {
        ...state,
        searchTerm: action.searchTerm,
      };
    }
    case TypeKeys.CLEAR_WORKOUT_FILTERS: {
      return {
        ...state,
        filterCount: 0,
        filters: noWorkoutFilters(),
        searchTerm: null,
      };
    }
  }
  return state;
};

export default workouts;

/////

function noWorkoutFilters(): WorkoutFilters {
  return {
    classification: {
      standard: false,
      kids: false,
    },
    dataType: {
      workouts: false,
      studioWorkouts: false,
      meditations: false,
    },
    difficulty: {
      1: false,
      2: false,
      3: false,
    },
    category: {
      strength: false,
      cardio: false,
      yoga: false,
      pilates: false,
      stretching: false,
      pt: false,
      barre: false,
    },
    impact: { low: false, normal: false },
    subCategory: {
      full: false,
      upper: false,
      lower: false,
      core: false,
      back: false,
      butt: false,
    },
    timingStyle: {
      standard: false,
      circuit: false,
      yoga: false,
      rep: false,
      seven: false,
    },
    equipment: {
      kettlebell: false,
      bodyweight: false,
      dumbbell: false,
      band: false,
      loop: false,
      foamroller: false,
      barre: false,
      chair: false,
      pilatesball: false,
    },
    fitnessGoal: {
      GOAL_HEALTH: false,
      GOAL_BUILD: false,
      GOAL_FLEXIBILITY: false,
      GOAL_INJURY: false,
      GOAL_LOSE: false,
      GOAL_ENDURANCE: false,
      GOAL_TONE: false,
      GOAL_SPORTS: false,
      GOAL_RELAXATION: false,
    },
  };
}

function countFilters(filters: WorkoutFilters) {
  let activeFilterCount = 0;
  Object.keys(filters).map((filter) => {
    Object.keys(filters[filter]).map((option) => {
      if (filters[filter][option]) {
        activeFilterCount++;
      }
    });
  });
  return activeFilterCount;
}
